import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router';
import { useRemitReportingEntrypoint } from 'src/apis/remit-reporting/use-remit-reporting-entrypoint';
import { PageSpinner } from 'src/components/spinner-container';
import { useOptionalExternalTrade } from 'src/pages/reporting/secondary-trading/external-trades/details/use-optional-external-trade';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const ExternalTradeEdit: FC = () => {
  const { externalTradeId } = useParams<{
    externalTradeId: string;
  }>();

  const remitReportingEntrypoint = useRemitReportingEntrypoint();
  const canEdit =
    !!remitReportingEntrypoint.response?.data._links?.['update-external-trade'];
  const externalTradeRequest = useOptionalExternalTrade(
    canEdit ? externalTradeId : null
  );

  if (!remitReportingEntrypoint.response) return <PageSpinner />;

  if (!canEdit) throw new Forbidden();

  if (!externalTradeRequest?.response) return <PageSpinner />;

  return <Page externalTrade={externalTradeRequest.response.data} />;
};
